import React, { useState } from "react";

import { Radio, Grid, InputLabel, Select, MenuItem } from "@material-ui/core";

import { useTranslation } from "react-i18next";

const NthOfMonth = {
  FIRST: "first",
  SECOND: "second",
  THIRD: "third",
  FOURTH: "fourth",
  LAST: "last",
};

const WeekDay = {
  MONDAY: "monday",
  TUESDAY: "tuesday",
  WEDNESDAY: "wednesday",
  THURSDAY: "thursday",
  FRIDAY: "friday",
  SATURDAY: "saturday",
  SUNDAY: "sunday",
};

const MonthDaySelector = () => {
  const { t } = useTranslation();
  const [everyNthDay, setEveryNthDay] = useState(1);
  const [nthOfMonth, setNthOfMonth] = useState(NthOfMonth.FIRST);
  const [weekDay, setWeekDay] = useState(WeekDay.MONDAY);

  const [isEveryNthDayMode, setIsEveryNthDayMode] = useState(true);

  return (
    <Grid container spacing={3}>
      {/* <FormControl>
        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          defaultValue="female"
          name="radio-buttons-group"
        > */}
      <Grid container spacing={3}>
        <Grid item xs={2} sm={1}>
          {/* <FormControlLabel value="female" control={<Radio />} /> */}
          <Radio
            checked={isEveryNthDayMode}
            onChange={(e) => setIsEveryNthDayMode(e.target.checked)}
            value="a"
            name="radio-buttons"
            inputProps={{ "aria-label": "A" }}
          />
        </Grid>
        <Grid item xs={22} sm={11}>
          <InputLabel htmlFor="everyNthDay">&nbsp;</InputLabel>
          <Select
            id="everyNthDay"
            name="everyNthDay"
            value={everyNthDay}
            onChange={(e) => setEveryNthDay(e.target.value)}
            fullWidth
          >
            {[...Array.from(Array(31).keys()).map((v) => v + 1), -1].map(
              (value, i) => (
                <MenuItem key={i} value={value}>
                  {`${value === -1 ? t("last_day") : t("day") + " " + value}`}
                </MenuItem>
              ),
            )}
          </Select>
        </Grid>
      </Grid>
      {/* <Grid item xs={6} sm={3}>
        <FormControlLabel value="male" control={<Radio />} />
      </Grid> */}
      <Grid container spacing={3}>
        <Grid item xs={2} sm={1}>
          <Radio
            checked={!isEveryNthDayMode}
            onChange={(e) => setIsEveryNthDayMode(!e.target.checked)}
            value="b"
            name="radio-buttons"
            inputProps={{ "aria-label": "B" }}
          />
        </Grid>
        <Grid item xs={11} sm={4}>
          <InputLabel htmlFor="nthOfMonth">&nbsp;</InputLabel>
          <Select
            id="nthOfMonth"
            name="nthOfMonth"
            value={nthOfMonth}
            onChange={(e) => setNthOfMonth(e.target.value)}
            fullWidth
          >
            {Object.values(NthOfMonth).map((value, i) => (
              <MenuItem key={i} value={value}>
                {t(value)}
              </MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid item xs={11} sm={7}>
          <InputLabel htmlFor="weekDay">&nbsp;</InputLabel>
          <Select
            id="weekDay"
            name="weekDay"
            value={weekDay}
            onChange={(e) => setWeekDay(e.target.value)}
            fullWidth
          >
            {Object.values(WeekDay).map((value, i) => (
              <MenuItem key={i} value={value}>
                {t(value)}
              </MenuItem>
            ))}
          </Select>
        </Grid>
      </Grid>
      {/* </RadioGroup>
      </FormControl> */}
    </Grid>
  );
};

export default MonthDaySelector;



// WEBPACK FOOTER //
// ./src/components/MonthDaySelector.js